import SystemHealthComponent from '../Components/SystemHealth/SystemHealthComponent';

function SystemHealthPage() {
  return <SystemHealthComponent />;
}

export default SystemHealthPage;
